/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';
import { Formik, Form, FormikValues, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { useMutation } from '@tanstack/react-query';
import { SignInForm } from '../core/models';
import { SignIn } from '../../../apis/app.service';
import { useAuth } from '../../../store/AuthProvider';
import { User } from '../../../store/core/models';

const AuthSchema = Yup.object({
  email: Yup.string().email().required().label('Email'),
  password: Yup.string().required().label('Password'),
});
const initialValues = {
  email: '',
  password: '',
  type: 'internal',
};

export default function SignInPage() {
  const { token, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token) {
      navigate('/users', { replace: true });
    }
  }, [navigate, token]);
  const mutation = useMutation({
    mutationFn: SignIn,
    onSuccess: (res) => {
      const { message, data } = res;
      toast.success(message, {
        duration: 3000,
        position: 'top-right',
      });

      const { _id, email, phoneNumber, name, role } = data.user;
      const [firstName, lastName] = name.split(' ');

      const user: User = {
        _id,
        firstName,
        lastName: lastName || null,
        email,
        phoneNumber: phoneNumber.slice(4),
        role,
      };

      login(data.token, user);
    },
    onError(error: Error) {
      const { message } = error;
      toast.error(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
  });
  const submitForm = async (values: SignInForm, actions: FormikValues) => {
    mutation.mutate(values);
  };
  return (
    <div className="card Auth_card">
      <h3 className="text-center">Welcome Back</h3>
      <h5 className="text-center">Sign in to your account</h5>
      <div className="card-body ">
        <Formik
          validationSchema={AuthSchema}
          initialValues={initialValues}
          onSubmit={submitForm}
          enableReinitialize={true}
        >
          {(formik) => (
            <Form className="form" noValidate>
              <div className="">
                <div className="mb-3">
                  <label className="form-label">Email address</label>
                  <input
                    type="email"
                    name="email"
                    onChange={formik.handleChange}
                    className="form-control"
                    aria-describedby="email"
                  />
                  <div className="text-danger">
                    <ErrorMessage name="email" />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    name="password"
                    type="password"
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                  <div className="text-danger">
                    <ErrorMessage name="password" />
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  style={{ backgroundColor: '#00a9f3', borderColor: '#00a9f3' }}
                >
                  Sign in
                </button>
                <h6 className="my-2">
                  Not registerd?
                  <Link to="../signup">
                    <a> Create an account</a>
                  </Link>
                </h6>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}
